'use client';
import clsx from 'clsx';

import { Alter25Badge } from '@/components/alter25/Alter25Badge';
import FiveStars from '@/components/FiveStars';
import { CircleCheck } from '@/components/icons/CircleCheck';

interface ProductReviewProps {
  className?: string;
}

export const ShopSwabKitProductReview: React.FC<ProductReviewProps> = ({ className }) => {
  return (
    <div className={clsx('rounded-lg border border-1 border-badge-gray p-6', className)}>
      <div
        className={clsx(
          //
          'mb-4 flex',
          'justify-start items-start flex-col',
          'sm:justify-between sm:items-center sm:flex-row'
        )}
      >
        <div className="responsive-text-16-18">Easy process for so many insights</div>
        <FiveStars score={5} className="order-first sm:order-none mb-3 sm:mb-0" />
      </div>
      <div className="responsive-text-15-16 font-light mb-4 sm:mb-6">
        Loved the Alter DNA kit experience. The swab process and mailing it back was straightforward
        and simple.
        <span className="mx-1 font-normal bg-highlight-green rounded-sm">
          The results were fascinating and actionable.
        </span>
        Having someone to walk through the report with me was ideal so I could ask questions real
        time, but the report itself was very easy to understand.
      </div>
      <div className="tracking-[-0.48px] mb-2">Kathryn S.</div>
      <Alter25Badge
        darkText="Verified"
        lightText="Owner"
        icon={<CircleCheck className="text-checkmark-green w-[18px] h-[18px]" />}
      />
    </div>
  );
};
